import { motion } from 'motion/react';
import { C } from '../../constants/colors.js';

export function PB({ current, total, color }) {
  const pct = Math.max(2, (current / total) * 100);
  return (
    <div className="w-full overflow-hidden rounded-finley-full bg-finley-bg-card/70 shadow-finley-sm" style={{ height: 10 }}>
      <motion.div
        className="h-full rounded-finley-full"
        initial={{ width: 0 }}
        animate={{ width: `${pct}%` }}
        transition={{ type: 'spring', stiffness: 100, damping: 15 }}
        style={{ background: color || C.primary }}
      />
    </div>
  );
}
